import React from 'react'
import { useEffect, useRef, useState } from "preact/hooks"
import Text from '../Global/Text';

const AnchorModal = ({popup, desc, additionalPopup, setAdditionalPopup, setPopupClosed}) => {
    let newPopup = popup;
    let singularPopup = false;    
    const modelEventCapturer = useRef(null);
    const additionalModelEventCapturer = useRef(null);

    if(!desc[popup]){
        newPopup = Object.keys(desc).find(key => desc[key].name === popup);
        singularPopup = true;
    }

    useEffect(() => {
        const modalElement = modelEventCapturer.current;
        const additionalModalElement = additionalModelEventCapturer.current;

        if (modalElement) {
            modalElement.open()
            modalElement.addEventListener('closed', handlePopupClose);
        }
        if(additionalModalElement) {
            additionalModalElement.addEventListener('opened', handleAdditionalPopupOpen);
            additionalModalElement.addEventListener('closed', handleAdditionalPopupClose);
        }

        // Cleanup event listeners on component unmount
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('closed', handlePopupClose);
            }
            if(additionalModalElement) {
                additionalModalElement.removeEventListener('opened', handleAdditionalPopupOpen);
                additionalModalElement.removeEventListener('closed', handleAdditionalPopupClose);
            }
        };
    }, []);

    const handlePopupClose = () => {
        setPopupClosed(true)
    }

    const handleAdditionalPopup = (e, sectionName) => {
        e.preventDefault();
        setAdditionalPopup(sectionName)
    }

    const handleAdditionalPopupClose = () => {   
        setAdditionalPopup('')
        const modalElement = modelEventCapturer.current;

        if (modalElement) {
            modalElement.open();
            setPopupClosed(false)
        }
    };

    const handleAdditionalPopupOpen = () => {   
        const modalElement = modelEventCapturer.current;

        if (modalElement) {
            modalElement.close();
        }
    };

  return (
    <div className='additional_coverages_content_coverage_main'>
        {singularPopup === true ?
            <anchor-modal ref={modelEventCapturer} className="anchor-modal-main">
            <h5 className="popup_content_heading">{popup}</h5>
            <div className="popup_content_divider"></div>
            {typeof desc[popup] === "string" && 
                <span className="popup_content_para">
                    <Text value={desc[popup]} />    
                </span>
            }
            {typeof desc[newPopup] === "object" && 
                <span className="popup_content_para">
                    <Text value={desc[newPopup]?.longDesc} />    
                </span>
                }
            </anchor-modal>
            :
            <>
                <anchor-modal ref={modelEventCapturer} className="anchor-modal-main">
                    <h5 className="popup_content_heading">{popup}</h5>
                    <div className="popup_content_divider"></div>
                    {typeof desc[popup] === "string" && 
                        <span className="popup_content_para">
                            <Text value={desc[popup]} />    
                        </span>
                    }
                    {typeof desc[popup] === "object" && 
                        Object.entries(desc[popup]).map(([section, content]) => (
                            <div key={section} className="popup_content_additional">
                                <anchor-icon name="check" size="xsmall"/>
                                <button 
                                    className="popup_content_additional_button"
                                    onClick={(e) => handleAdditionalPopup(e, section)}
                                >
                                    {section}
                                </button>
                            </div>
                        ))}
                </anchor-modal> 
                <anchor-modal
                    isVisible={desc?.[popup] && typeof desc[popup] === 'object' && Object.keys(desc[popup]).includes(additionalPopup)}
                    ref={additionalModelEventCapturer}
                    className="anchor-modal-additional"
                >
                    {desc?.[popup] && typeof desc[popup] === 'object' && desc[popup][additionalPopup] && (
                        <>
                            <h5 className="popup_content_heading">{popup}</h5>
                            <div className="popup_content_divider"></div>
                            <h4 className="popup_content_subheading">{additionalPopup}</h4>
                            <span className="popup_content_para">
                                <Text value={desc[popup][additionalPopup]} />    
                            </span>
                        </>
                    )}
                </anchor-modal>
            </>
        }
    </div>
  )
}

export default AnchorModal